module.exports = __webpack_public_path__ + "static/royal-college-489226dde64199c1df821e54c541c0b2.svg";